<template>
    <div class="main">
        <div class="grid-container" v-if="collection != null">
            <div class="grid-x">
                <div class="small-12 cell text-center">
                    <h1>Your collection</h1>
                </div>
            </div>
            <div class="grid-x" v-if="collection.length == 0">
                <div class="small-12 cell">
                    <p>No sneakers in collection.</p>
                </div>
            </div>
            <div class="grid-x grid-margin-x" v-else>
                <div v-for="sneaker in collection" class="small-12 medium-6 large-4 cell">
                    <router-link :to="{ path: `/sneakers/${sneaker.brand}/${sneaker.slug}` }" v-if="sneaker != null" class="card">
                        <img :src="sneaker.image_url" />
                        <div class="card-section">
                            <p class="lead">{{ sneaker.brand }}</p>
                            <p>{{ sneaker.model_name }}</p>
                            <div class="grid-x card-info">
                                <div class="small-5 small-offset-1">
                                    <p>{{ sneaker.release_date_pretty }}</p>
                                </div>
                                <div class="small-5 small-offset-1">
                                    <p v-if="sneaker.original_price != 'TBA'">€{{ sneaker.original_price }}</p>
                                    <p v-else>{{ sneaker.original_price }}</p>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'collection',
    computed: {
        collection: function () {
            return this.$store.getters.user.collection
        }
    }
}
</script>



// WEBPACK FOOTER //
// Collection.vue?a27827ee